import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import {
    Box,
    Tooltip
} from '@mui/material';
import { Iconify } from 'src/components';
import { updatePracticeIdToChange } from 'src/redux/slices/practiceTreatmentList';
import capitalizeFirstLetter from 'src/utils/capitalizedFunc';
import useCustomSnackbar from 'src/hooks/useCustomSnackbar';
import { leadPage } from '../../../../redux/slices/lead';
import { dispatch, useSelector } from '../../../../redux/store';
import { viewDetailBoxStyle } from '../../../../styles/NewLead';

const ViewDetailsField = ({
    row,
    tableTitle,
    tablePath,
    interPractice
}) => {
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useCustomSnackbar();

    const goToViewDetailPage = async () => {
        dispatch(leadPage({ name: tableTitle, path: tablePath }));
        if (interPractice) {
            navigate(`/dashboard/practice/${row?.practiceId}/lead-detail/${row.lead_id}`);
            dispatch(updatePracticeIdToChange(row?.practiceId));
            await new Promise(resolve => setTimeout(resolve, 2000));
            enqueueSnackbar(`Practice switched to ${capitalizeFirstLetter(row?.practiceName)}`, {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
        }
        else
            navigate(`/dashboard/practice/${practiceId}/lead-detail/${row.lead_id}`);
    };

    return (
        <Tooltip placement='bottom' title={'View details'}>
            <Box
                onClick={() => goToViewDetailPage()}
                onMouseDown={() => goToViewDetailPage()}
                sx={viewDetailBoxStyle}
            >
                <Box sx={{ lineHeight: 0 }}><Iconify icon={'ant-design:file-search-outlined'} width={22} height={22} /></Box>
            </Box>
        </Tooltip>
    );
};

ViewDetailsField.propTypes = {
    row: PropTypes.object,
    tableTitle: PropTypes.string,
    tablePath: PropTypes.string,
    interPractice: PropTypes.bool
};

export default ViewDetailsField;
